
import Vue from "vue";
import { UserConfigService } from "@/services/user-config-service";
import { Permissions } from "@/models/user-configs/permissions";
import {AuthService} from "@/services";
import {MODULE} from "@/config/modules";

export default Vue.extend({
	data(){
		return {
			UserConfigService
		};
	},
	computed: {
		MODULE() {
			return MODULE;
		},
		isAdmin():boolean {
			return this.UserConfigService.hasCurrentUserPermission((permissions:Permissions):boolean=>{
				return permissions.IsAdmin;
			});
		},
	},
	methods: {
		hasModule(id:number):boolean {
			return AuthService.hasModule(id);
		},
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
